<template>
  <a href="/" class="logo">
    <div class="img-wrap"></div>
    <div class="img-wrap">
      <img
        src="/img/swampum-logo.png"
        width="144"
        height="36"
        alt="Swampum"
        class="desktop-logo"
      />
      <img
        src="/img/swampum-polygon.png"
        width="48"
        height="40"
        alt="Swampum"
        class="mobile-logo"
      />
    </div>
  </a>
</template>
<script>
export default {
  name: "SLogo",
};
</script>

<style scoped>
.desktop-logo {
  display: none;
}
.logo {
  width: fit-content;
}
@media screen and (min-width: 480px) {
  .mobile-logo {
    width: 53px;
    height: 44px;
  }
}
@media screen and (min-width: 720px) {
  .mobile-logo {
    width: 60px;
    height: 50px;
  }
}
@media screen and (max-width: 1023px) {
  .mobile-logo {
    display: block;
  }
  .desktop-logo {
    display: none;
  }
}
@media screen and (min-width: 1112px) {
  .mobile-logo {
    display: none;
  }
  .desktop-logo {
    display: block;
  }
}
</style>
